module.exports = __webpack_public_path__ + "img/whatsapp.8e26c48.svg";